module.exports = __webpack_public_path__ + "img/img_bianma.4323ce84.png";